import { createContext, useContext } from "react";

export const ThirdPartyContext = createContext({
    includeThirdParty: false,
    toggleThirdParty: () => {},
    includeMirrorMatches: true,
    toggleMirrorMatches: () => {},
});

export function useIncludeThirdParty() {
    return useContext(ThirdPartyContext).includeThirdParty;
}

export function useToggleThirdParty() {
    return useContext(ThirdPartyContext).toggleThirdParty;
}

export function useIncludeMirrorMatches() {
    return useContext(ThirdPartyContext).includeMirrorMatches;
}

export function useToggleMirrorMatches() {
    return useContext(ThirdPartyContext).toggleMirrorMatches;
}
